<template>
	<div class="media-list">
		<header class="media-list__header">
			<p>{{ t('popup.mediaList.header.name') }}</p>
			<p>{{ t('popup.mediaList.header.check') }}</p>
		</header>
		<div class="media-list__content scrollbar-custom">
			<div
				v-for="file of files"
				:key="file.name"
				class="media-item"
			>
				<div class="media-item__title">
					<i class="fas fa-file-image"></i>
					<span>{{ file.name }}</span>
				</div>
				<div class="media-item__message">
					<span>{{ file.message }}</span>
					<i
						class="fas"
						:class="{
							'fa-times bg--red' : !file.accepted,
							'fa-check bg--greeny-blue' : file.accepted
					}"
					></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {useI18n} from "vue-i18n";

export default {
	props: {
		files: {
			type: Array,
		}
	},
	setup(props, {emit}){
		const {t} = useI18n();
		
		return{
			t,
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/media/media-list";
@use "@/scss/sections/editor/media/media-item";
</style>